import { useMemo } from "react";
import { Link } from "react-router-dom";
import type { MangaItem } from "@/mocks/comics";
import { mangaList } from "@/mocks/comics";

interface RelatedSectionProps {
  comic: MangaItem;
}

export default function RelatedSection({ comic }: RelatedSectionProps) {
  const related = useMemo(() => {
    return mangaList
      .filter((item) => item.slug !== comic.slug && item.categorySlugs.some((c) => comic.categorySlugs.includes(c)))
      .sort((a, b) => b.rating - a.rating)
      .slice(0, 4);
  }, [comic]);

  if (related.length === 0) return null;

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4">
      <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
        <i className="ri-heart-3-line text-primary-500" aria-hidden="true" />
        猜你喜欢
      </h3>
      <ul className="mt-4 space-y-3">
        {related.map((item) => (
          <li key={item.slug}>
            <Link to={`/article/${item.slug}`} className="group flex items-center gap-3 cursor-pointer">
              <img
                src={item.cover}
                alt={`${item.title} 封面`}
                className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </p>
                <p className="mt-1 truncate text-xs text-foreground-600">{item.latestChapter}</p>
                <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500" aria-hidden="true" />
                    {item.rating.toFixed(1)}
                  </span>
                  <span>{item.status}</span>
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to={`/category/${comic.categorySlugs[0]}`}
        className="mt-4 inline-flex w-full items-center justify-center gap-1 rounded-md border border-foreground-950/15 py-2 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600 cursor-pointer"
      >
        更多同类漫画<i className="ri-arrow-right-line" aria-hidden="true" />
      </Link>
    </div>
  );
}